module.exports = __webpack_public_path__ + "media/images/emoticons/club-43cab2a4fc7ab6aa9a73265a470bdda3.gif";